import { Component, Input, AfterViewInit } from '@angular/core';
import { SocialProvider, SocialPost, SocialService } from './social.service';

@Component({
  selector: 'app-social',
  templateUrl: '../templates/social.component.html',
  styleUrls: ['../styles/components/social.component.less'],
  providers: [SocialService]
})
export class SocialComponent implements AfterViewInit {
  @Input('provider') provider: SocialProvider;
  @Input('btntext') btntext: string;
  @Input('heading') heading: string;
  @Input('count') count: string;
  posts: SocialPost[] = [];
  placeLoaders: any[] = [];
  subscribeLink: string = '';

  constructor(private socialService: SocialService) {}

  public async ngAfterViewInit() {
    this.placeLoaders.length = Number(this.count);
    this.placeLoaders.fill('');

    this.subscribeLink = this.socialService.getSubscribeLink(this.provider);

    if (typeof window === 'undefined') return;

    try {
      this.posts = await this.socialService.getPosts(this.provider, this.count);
    } catch (e) {
      console.error(`error loading posts from ${this.provider}`);
    }
  }
}
